var exports = {
  "x": "footerContainer__tsngW_",
};

module.exports = exports;
